import Const from './const'
import { getAuthority } from './data'
export const sprintf = require('locutus/php/strings/sprintf')
export const date = require('locutus/php/datetime/date')

/**
 * @description hex string arrayBuffer 的转换
 */
export function hexToArrayBuffer(hex) {
    if (typeof hex !== 'string') {
        throw new TypeError('Expected input to be a string')
    }

    if ((hex.length % 2) !== 0) {
        throw new RangeError('Expected string to be an even number of characters')
    }

    let array = new Uint8Array(hex.length / 2);

    for (let i = 0; i < hex.length; i += 2) {
        array[i / 2] = parseInt(hex.substring(i, i + 2), 16)
    }

    return array
}
export function arrayBufferToHex(buffer) {
    let hex = '';
    for (let i = 0; i < buffer.length; i++) {
        let h = '00' + buffer[i].toString(16);
        hex += h.substr(-2);
    }
    return hex
}
export function stringToArrayBuffer(content, len) {
    let length = len || content.length
    let array = new Uint8Array(length);
    for (let i = 0; i < content.length; i++) {
        array[i] = content.charCodeAt(i)
    }
    return array
}
export function arrayBufferToString(buffer) {
    let content = '';
    for (let i = 0; i < buffer.length; i++) {
        content += String.fromCharCode(buffer[i]);
    }
    return content;
}
export function arrayBufferToGBK(buffer) {
	let td = new TextDecoder('GBK');
	return td.decode(buffer);
}

/**
 * @description 判断当前登录用户是否有某项权限
 * @param {String,String} keys 权限的关键字
 */
export function auth(...arr) {
    if (!arr.length) {
        return true
    }
    const rolesMap = getAuthority() || {};
    return arr.some(key => {
        return rolesMap[key];
    });
}

/**
 * @description 深拷贝
 * @param {Object} target
 */
export function deepCopy(target) {
    let copyed_objs = [];
    function _deepCopy(target){
        if (typeof target === 'string') {
            return target.trim()
        }
        if((typeof target !== 'object')||!target){return target;}
        for(let i= 0 ;i<copyed_objs.length;i++){
            if(copyed_objs[i].target === target){
                return copyed_objs[i].copyTarget;
            }
        }
        let obj = {};
        if(Array.isArray(target)){
            obj = [];
        }
        copyed_objs.push({target:target,copyTarget:obj})
        Object.keys(target).forEach(key=>{
            if(obj[key]){ return;}
            obj[key] = _deepCopy(target[key]);
        });
        return obj;
    }
    return _deepCopy(target);
}
/**
 * 判断传入的对象是否为空
 * @param {Object} obj
 */
export function isEmptyObj(obj) {
    if (!obj) {
        return true
    }
    return !Object.keys(obj).length
}

/**
 * @description:数值转换 将后端传来的数值转换成对应值
 * @param {Number} val 被除数 需要转换的数值
 * @param {Number} divisor 除数 默认为100
 * @param {Number} dp 保留几位小数 默认为2
 * @param {Number} type 乘法/除法 false=除法 true=乘法
 */
export function countFilter(val = 0 ,divisor = 100, dp = 2, type = false) {
    if (val == 0) { return 0 }
    if (type) {
        return parseFloat((val * divisor).toFixed(dp))
    } else {
        return parseFloat((val / divisor).toFixed(dp))
    }
}

/**
 * @description 检测字符串是否符合预设的正则规则
 * @param {String} str 需要检测的字符串
 * @param {String} type 正则规则类型
 * @param {RegExp} custom 当type为“custom”需传入自定义正则
 */
export function regRuleTest(str = '', type, custom) {
    console.log('regRuleTest str:', str, ' type:', type)
    str = str.toString()
    if (!str) { return false }
    str.trim()
    let regRule = ''
    switch (type) {
        case 'int': regRule = /^[1-9]\d*$/; break; // 整数
        case 'float1': regRule = /^(\d+)(\.[0-9]{0,1})?$/; break; // 一位小数
        case 'float2': regRule = /^(\d+)(\.[0-9]{0,2})?$/; break; // 两位小数
        case '400': regRule = /^400([-]?)[0-9]{7}$/; break; // 400电话
        case '800': regRule = /^800([-]?)[0-9]{7}$/; break; // 800电话
        case 'phone': regRule = /^1[3456789]\d{9}$/; break; // 手机号
        case 'landline': regRule = /^(\d{1,3})([1-9]\d{1,2})([-]?)(\d{7,8})$/; break; // 固话
        case 'contact': regRule = /(^400([-]?)[0-9]{7}$)|(^800([-]?)[0-9]{7}$)|(^1[3456789]\d{9}$)|(^\d{1,3})([1-9]\d{1,2})([-]?)(\d{7,8}$)/ ; break; // 400正则 | 800正则 | 手机号 | 固话
        case 'idcard18': regRule = /^([1-6][1-9]|50)\d{4}(18|19|20|21)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; break; // 身份证 18位
        case 'idcard15': regRule = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/; break; // 身份证 15位

        case 'custom': regRule = custom; break; // 手动传入正则规则
    }
    console.log('regRule:', regRule)
    if (regRule) {
        return regRule.test(str)
    }
    return false
}

// oss 文件地址处理
export function filePathFilter(item) {
    if (!item || typeof item !== 'string') {
        return ''
    }
    if (item.includes(',')) {
        let arr = item.split(',')
        item = arr[0]
    }
    if (item.includes("http")) {
        return item
    } else {
        return Const.NET.FILE_URL_PREFIX + item
    }
}


// 获取从start开始长度为length的位bit值
export function getBits(b,start,length) {
    let bit = ( (b>>start) & (0xFF>>(8-length)) );
    return bit;
}
// 获取第i位的bit值 并判断
export function getBit(b,i) {
    let bit = (b >> i) & 0x1;
    console.log('bit:', bit)
    return bit !== 0;
}
// 将字节byte的第index位设置为1或0 默认置1
export function setBit(byte, index, flag = true) {
    if (flag) {
        return byte |= (1 << index);
    } else {
        return byte &= ~(1 << index);
    }
}